import React from 'react';
import { Schedule as ScheduleModel } from '../../data/entities/booking/Schedule';
import { ScheduleBlock as ScheduleBlockModel } from '../../data/entities/booking/ScheduleBlock';
import style from './styles/Schedule.module.scss';
import { to12HourTime } from '../../utils';

interface ScheduleProps {
  schedule: ScheduleModel;
  editable?: boolean;
  className?: string;
}

interface ScheduleBlockProps {
  block: ScheduleBlockModel;
  className?: string;
}

const daysOfWeek = [
  { name: 'Sunday', value: 0 },
  { name: 'Monday', value: 1 },
  { name: 'Tuesday', value: 2 },
  { name: 'Wednesday', value: 3 },
  { name: 'Thursday', value: 4 },
  { name: 'Friday', value: 5 },
  { name: 'Saturday', value: 6 },
];

const Schedule: React.FC<ScheduleProps> & {
  Block: React.FC<ScheduleBlockProps>;
} = ({ schedule, className, editable = false }) => {
  // Group schedule blocks by day of week
  const blocksByDay: { [key: number]: ScheduleBlockModel[] } = {};
  daysOfWeek.forEach(day => {
    blocksByDay[day.value] = schedule.scheduleBlocks.filter(
      block => block.dayOfWeek === day.value
    );
  });

  const leftColumn = daysOfWeek.slice(0, 4); // Sun-Wed
  const rightColumn = daysOfWeek.slice(4);   // Thu-Sat

  const renderDay = (day: typeof daysOfWeek[0]) => {
    const hasBlocks = blocksByDay[day.value].length > 0;
    
    return (
      <div key={day.value} className="mb-3">
        <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
          <span className="fw-bold text-primary">{day.name}</span>
        </div>
        <div>
          {hasBlocks ? (
            blocksByDay[day.value].map(block => (
              <Schedule.Block className="mb-2" key={block.id} block={block} />
            ))
          ) : (
            <div className="w-100">
              <span className={style.closed}>
                Unavailable
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`${className}`}>
      <div className="row g-4">
        <div className="col-24 col-xl-12">
          {leftColumn.map(renderDay)}
        </div>
        <div className="col-24 col-xl-12">
          {rightColumn.map(renderDay)}
        </div>
      </div>
    </div>
  );
};

Schedule.Block = ({ block, className }: ScheduleBlockProps) => {
  return (
    <div className={`d-flex flex-nowrap align-items-center gap-2 ${className}`}>
      <span className={style.time}>
        {to12HourTime(block.startTime)}
      </span>
      <span className="text-muted">→</span>
      <span className={style.time}>
        {to12HourTime(block.endTime)}
      </span>
    </div>
  );
};

export default Schedule;
